import React from 'react';

export function ProgressTinybar({ value, target }) {
  if (!target) return null;
  const pct = Math.min(100, (value / target) * 100);
  return (
    <div className="tinybar">
      <div style={{
        width: `${pct}%`,
        background: value >= target ? 'var(--ok)' : value > 0 ? 'var(--accent)' : 'var(--ink-4)',
      }} />
    </div>
  );
}
